'use client';

import Script from 'next/script';

export default function CapmanScript() {
  return (
    <Script
      src="https://capman.kr/sdk/capman-feed.js"
      strategy="afterInteractive"
      onLoad={() => {
        CapmanFeed.init({
          apiKey: 'cfk_74229650b29348c34972396ca16828de4119ee2ce5b1aa00',
          projectId: 'cmlitwfpz000nl8042fqekcvz',
          features: ['record', 'report'],
          screenshot: 'html-to-image'
        });
      }}
    />
  );
}
